import React, { useState } from 'react';
import './FurosList.css';

function FurosList({
  furosVerticais = [],
  furosHorizontais = [],
  rasgos = [],
  selectedFuro,
  onSelectFuro,
  onDeleteFuro,
  onDeleteRasgo,
  rasgoEditandoIndex = null,
  onSelectRasgo,
  selectedFuros,
  onToggleFuroSelecionado,
}) {
  const totalFuros = furosVerticais.length + furosHorizontais.length;

  const [collapsed, setCollapsed] = useState({ vertical: false, horizontal: false, rasgo: false });

  const toggleSection = (key) =>
    setCollapsed(prev => ({ ...prev, [key]: !prev[key] }));

  const isSelected = (tipo, index) =>
    selectedFuro?.tipo === tipo && selectedFuro?.index === index;

  const handleSelect = (tipo, index, furo) => {
    // Contrato de seleção padronizado com Canvas3D.jsx — sempre inclui uid
    onSelectFuro?.({ tipo, index, uid: furo.uid, furo });
  };

  return (
    <div className="furos-list">
      {/* Header */}
      <div className="furos-header">
        <h3>
          <span className="header-icon">◉</span>
          Operações
        </h3>
        <span className="furos-count">{totalFuros + rasgos.length}</span>
      </div>

      {/* Lista */}
      <div className="furos-scroll">
        {totalFuros === 0 && rasgos.length === 0 ? (
          <div className="furos-empty">
            <span className="empty-icon">○</span>
            <p>Nenhuma operação</p>
            <small>Importe um arquivo MPR ou adicione manualmente</small>
          </div>
        ) : (
          <>
            {/* Furos Verticais */}
            {furosVerticais.length > 0 && (
              <div className="furos-section">
                <div className="section-header" onClick={() => toggleSection('vertical')}>
                  <span className="section-icon vertical">V</span>
                  <span>Verticais</span>
                  <span className="section-count">{furosVerticais.length}</span>
                  <span className={`section-chevron ${collapsed.vertical ? 'collapsed' : ''}`}>›</span>
                </div>
                {!collapsed.vertical && (
                  <div className="section-items">
                    {furosVerticais.map((furo, index) => {
                      const qtd = furo.quantidade || 1;
                      const isGrupo = qtd > 1;
                      const uid = furo.uid || `v-${index}`;
                      const isChecked = selectedFuros?.has(uid) || false;
                      return (
                        <div
                          key={uid}
                          className={`furo-item ${isSelected('vertical', index) ? 'selected' : ''} ${furo.lado === 'LI' || furo.lado === 'LSU' ? 'bottom' : 'top'}`}
                          onClick={() => handleSelect('vertical', index, furo)}
                        >
                          {onToggleFuroSelecionado && (
                            <input
                              type="checkbox"
                              className="furo-checkbox"
                              checked={isChecked}
                              onChange={() => onToggleFuroSelecionado(uid)}
                              onClick={(e) => e.stopPropagation()}
                              title="Selecionar para regra especial"
                            />
                          )}
                          <span className="furo-id">V{index + 1}</span>
                          <span className={`furo-badge ${furo.lado === 'LI' || furo.lado === 'LSU' ? 'inferior' : 'superior'}`}>
                            {furo.lado === 'LI' || furo.lado === 'LSU' ? 'INF' : 'SUP'}
                          </span>
                          <span className="furo-badge diam">Ø{furo.diametro}</span>
                          {isGrupo && (
                            <span className="furo-badge grupo" title={`${qtd} furos, passo ${furo.distancia}mm (${furo.direcao_replicacao === 'y' ? 'eixo Y' : 'eixo X'})`}>
                              {qtd}× {furo.distancia}mm
                            </span>
                          )}
                          <span className="furo-dot">·</span>
                          <span className="furo-prof">{furo.profundidade || 11}mm</span>
                          {onDeleteFuro && (
                            <button
                              className="furo-delete"
                              onClick={(e) => { e.stopPropagation(); onDeleteFuro('vertical', index); }}
                              title={isGrupo ? `Excluir grupo (${qtd} furos)` : 'Excluir'}
                            >×</button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Furos Horizontais */}
            {furosHorizontais.length > 0 && (
              <div className="furos-section">
                <div className="section-header" onClick={() => toggleSection('horizontal')}>
                  <span className="section-icon horizontal">H</span>
                  <span>Horizontais</span>
                  <span className="section-count">{furosHorizontais.length}</span>
                  <span className={`section-chevron ${collapsed.horizontal ? 'collapsed' : ''}`}>›</span>
                </div>
                {!collapsed.horizontal && (
                  <div className="section-items">
                    {furosHorizontais.map((furo, index) => {
                      const qtd = furo.quantidade || 1;
                      const isGrupo = qtd > 1;
                      return (
                        <div
                          key={furo.uid || `h-${index}`}
                          className={`furo-item horizontal ${isSelected('horizontal', index) ? 'selected' : ''}`}
                          onClick={() => handleSelect('horizontal', index, furo)}
                        >
                          <span className="furo-id">H{index + 1}</span>
                          <span className="furo-badge lado">{furo.lado || 'XP'}</span>
                          <span className="furo-badge diam">Ø{furo.diametro}</span>
                          {isGrupo && (
                            <span className="furo-badge grupo" title={`${qtd} furos, passo ${furo.distancia}mm (${furo.direcao_replicacao === 'y' ? 'eixo Y' : 'eixo X'})`}>
                              {qtd}× {furo.distancia}mm
                            </span>
                          )}
                          <span className="furo-dot">·</span>
                          <span className="furo-prof">{furo.profundidade || 22}mm</span>
                          {onDeleteFuro && (
                            <button
                              className="furo-delete"
                              onClick={(e) => { e.stopPropagation(); onDeleteFuro('horizontal', index); }}
                              title={isGrupo ? `Excluir grupo (${qtd} furos)` : 'Excluir'}
                            >×</button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Rasgos */}
            {rasgos.length > 0 && (
              <div className="furos-section">
                <div className="section-header" onClick={() => toggleSection('rasgo')}>
                  <span className="section-icon">▬</span>
                  <span>Rasgos</span>
                  <span className="section-count">{rasgos.length}</span>
                  <span className={`section-chevron ${collapsed.rasgo ? 'collapsed' : ''}`}>›</span>
                </div>
                {!collapsed.rasgo && (
                  <div className="section-items">
                    {rasgos.map((rasgo, index) => (
                      <div
                        key={`r-${index}`}
                        className={`furo-item rasgo ${rasgoEditandoIndex === index ? 'selected' : ''}`}
                        onClick={() => onSelectRasgo?.(rasgoEditandoIndex === index ? null : index)}
                      >
                        <span className="furo-id">R{index + 1}</span>
                        <span className="furo-badge rasgo-face">{rasgo.face}</span>
                        <span className="furo-dot">·</span>
                        <span className="furo-prof">{rasgo.largura}×{rasgo.profundidade}mm</span>
                        {onDeleteRasgo && (
                          <button
                            className="furo-delete"
                            onClick={(e) => { e.stopPropagation(); onDeleteRasgo(index); }}
                            title="Excluir"
                          >×</button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default FurosList;
